<template>
    <div class="card card-default w-100">
        <div class="card-body">
            <h4><label for="`${id}-type`">Hardware Device Lookup</label></h4>

            <div class="input-group">
                <part-number-picker style="width: 300px; margin-right: -1px;"
                                    :class="['form-control', !model.partNumber ? '' : partNumberIsValid ? 'is-valid' : 'is-invalid']"
                                    :id="`${id}-type`" placeholder="Hardware Device Type"
                                    v-model="partNumberId" :allowed-types="['HardwareDevice']" :is-required="true"
                                    :is-valid.sync="partNumberIsValid" :part-number.sync="model.partNumber" />
                <input class="form-control" style="width: 150px;" :id="`${id}-serial`" placeholder="Serial Number"
                       v-model="model.serialNumber"
                       @keyup.enter="onGo" />
                <div class="input-group-append ml-auto">
                    <button class="btn btn-outline-secondary btn-sm" @click="useCamera = !useCamera">{{ useCamera ? 'Close' : 'Open' }} Camera </button>
                    <button @click="onGo" class="btn btn-success btn-sm px-4" :disabled="!isValid">Go</button>
                </div>
            </div>

            <div class="alert alert-info mt-2" v-if="loadingCamera">Accessing Camera...</div>
            <div class="alert alert-danger mt-2" role="alert" v-if="cameraError"><strong>Error:</strong> {{ cameraError }}</div>
            <qrcode-stream v-if="useCamera" @decode="onDecode" @init="onInit" class="mt-2"></qrcode-stream>
        </div>
    </div>
</template>

<script>
    import PartNumberPicker from 'common/components/part-number/part-number-picker';
    import { QrcodeStream } from 'vue-qrcode-reader';

    export default {
        props: {
            id: { type: String, default: 'part-number-picker' }, // prefix for inputs' id
        },

        emits: {
        },

        components: {
            'part-number-picker': PartNumberPicker,
            'qrcode-stream': QrcodeStream,
        },

        data() {
            return {
                loading: false,
                error: null,
                model: { partNumber: null, serialNumber: '' },
                partNumberId: null,
                partNumberIsValid: false,
                useCamera: false,
                cameraError: '',
                loadingCamera: false,
                output: '',
            }
        },

        methods: {
            onGo() {
                if (this.model.serialNumber) {
                    var regex = /^http:\/\/sk4\.info\/hw\/(.*?)\/(.*)$/;
                    var match = this.model.serialNumber.match(regex);
                    if (match && match[0] && match[1] && match[2]) {
                        this.$router.push({ path: `/hw/${match[1]}/${match[2]}` });
                        return;
                    }
                }

                if (this.isValid) {
                    this.$router.push({ path: `/hw/${this.urlEscape(this.model.partNumber.salesPartNumber)}/${this.urlEscape(this.model.serialNumber)}` });
                }
            },
            async onDecode(decodedString) {
                var splitString = decodedString.split('/');
                if (splitString.length == 6) {
                    // Get sales part number and serial number from the decoded string
                    // Example: http://sk4.info/hw/48001/48000001
                    var salesPartNumber = splitString[4].toUpperCase();
                    var serialNumber = splitString[5].toUpperCase();

                    try {
                        this.loading = true;
                        this.error = null;

                        var response = await this.$http.get(`/part-number/hardware-device/${salesPartNumber}`);

                        if (response && response.data && response.data.partNumberId && response.data.salesPartNumber) {
                            this.partNumberId = response.data.partNumberId;
                            this.partNumberIsValid = response.data.isHardwareDevice;
                            this.model.partNumber = response.data;
                        } else {
                            throw new Error('Response is missing or does not contain any data');
                        }

                        this.model.serialNumber = serialNumber;

                        this.$notify({
                            type: 'alert-success',
                            title: 'Hardware Device Found',
                            text: `Found in ${decodedString}`
                        });

                    } catch (error) {
                        this.$notify({
                            type: 'alert-danger',
                            title: 'Hardware Device Not Found',
                            text: error.message,
                        });
                        this.error = error;
                    } finally {
                        this.loading = false;
                        this.onGo();
                    }
                } else {
                    this.model.serialNumber = decodedString.toUpperCase();
                    this.onGo();
                }
            },
            async onInit(promise) {
                this.loadingCamera = true;
                try {
                    await promise;
                    // successfully initialized
                }
                catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.cameraError = 'User denied camera access permisson';
                    } else if (error.name === 'NotFoundError') {
                        this.cameraError = 'No suitable camera device installed';
                    } else if (error.name === 'NotSupportedError') {
                        this.cameraError = 'Page is not served over HTTPS (or localhost)';
                    } else if (error.name === 'NotReadableError') {
                        this.cameraError = 'Maybe camera is already in use';
                    } else if (error.name === 'OverconstrainedError') {
                        this.cameraError = 'Did you requested the front camera although there is none?';
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.cameraError = 'Browser seems to be lacking features';
                    }
                    this.useCamera = false;
                }
                finally {
                    this.loadingCamera = false;
                }
            },
            urlEscape(text) {
                if (!text) return text;

                return text.replaceAll('_', '_5F').replaceAll('/', '_2F');
            },
        },

        computed: {
            isValid() {
                if (this.loading) return false;
                if (!this.partNumberId) return false;
                if (!this.partNumberIsValid) return false;
                if (!this.model) return false;
                if (!this.model.partNumber) return false;
                if (!this.model.partNumber.salesPartNumber) return false;
                if (!this.model.serialNumber) return false;
                return true;
            },
        },

        watch: {
        },
    }
</script>

<style>
</style>